import * as React from 'react';
import classnames from 'classnames';
import * as styles from './Title.module.scss';

export interface TitleProps {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    className?: string;
    titleClassName?: string;
    subtitleClassName?: string;
    Component: React.ElementType;
}

function Title({
    title,
    subtitle,
    className,
    titleClassName,
    subtitleClassName,
    Component,
}: TitleProps) {
    return (
        <hgroup className={classnames(className, styles.root)}>
            <Component
                className={classnames(titleClassName, styles.title, {
                    [styles.hasSubtitle]: !!subtitle,
                })}
            >
                {title}
            </Component>
            {subtitle && (
                <p className={classnames(styles.subtitle, subtitleClassName)}>
                    {subtitle}
                </p>
            )}
        </hgroup>
    );
}

Title.defaultProps = {
    Component: 'h2',
};

export default Title;
